const eightAlphanumericRegex = /^[a-zA-Z0-9]{8}$/;

const isValidReferralCode = (referralCode: string): boolean =>
  eightAlphanumericRegex.test(referralCode);

export default isValidReferralCode;
